import api from './api';

const saasAdminApi = {
  // Statistics
  getStats: (period = 30) => api.get(`/admin/saas/stats?period=${period}`),
  
  // Subscriptions
  listSubscriptions: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return api.get(`/admin/saas/subscriptions${queryParams ? `?${queryParams}` : ''}`);
  },
  getSubscription: (id) => api.get(`/admin/saas/subscriptions/${id}`),
  createSubscription: (data) => api.post('/admin/saas/subscriptions', data),
  cancelSubscription: (id, data) => api.post(`/admin/saas/subscriptions/${id}/cancel`, data),
  
  // Locations and billing exemption
  listBusinesses: () => api.get('/admin/saas/businesses'),
  getExemptPlans: () => api.get('/admin/saas/exempt-plans'),
  setBillingExempt: (businessId, data) => api.post(`/admin/saas/businesses/${businessId}/billing-exempt`, data),
  clearBillingExempt: (businessId) => api.delete(`/admin/saas/businesses/${businessId}/billing-exempt`),

  // Payments
  listPayments: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return api.get(`/admin/saas/payments${queryParams ? `?${queryParams}` : ''}`);
  },
  createPayment: (data) => api.post('/admin/saas/payments', data),
  
  // Activity
  getActivity: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return api.get(`/admin/saas/activity${queryParams ? `?${queryParams}` : ''}`);
  },
  
  // Usage
  getUsage: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return api.get(`/admin/saas/usage${queryParams ? `?${queryParams}` : ''}`);
  }
};

export default saasAdminApi;

